import {
  UserManager,
  WebStorageStateStore,
} from '@soniq/util-auth'

// A silent sign in only stays on the page when we hold a refresh
// token. Without one oidc-client-ts runs the sign in in a hidden
// iframe, and that iframe can never report back here:
//
//  - the app is served with `X-Frame-Options: DENY`, so even our
//    own callback page cannot render inside a frame
//  - the app is served with `Cross-Origin-Embedder-Policy:
//    require-corp` (needed for the SharedArrayBuffer that
//    sqlite-wasm uses), which blocks documents that do not send
//    that header themselves
//  - Keycloak sends `frame-ancestors 'self'` and
//    `X-Frame-Options: SAMEORIGIN`, and it runs on a different
//    host to the app
//
// The iframe therefore sits there until oidc-client-ts gives up
// with `ErrorTimeout: IFrame timed out without a response`, ten
// seconds of the user waiting for nothing. Anything that wants a
// silent sign in checks for a refresh token first and signs in
// with a redirect instead — see `withAuthenticationRequired` and
// `~m/resource/sync.ts`.
export const userManager = new UserManager({
  authority: import.meta.env.VITE_AUTHORITY,
  client_id: import.meta.env.VITE_CLIENT_ID,
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
  // Keycloak's check session iframe is blocked the same way, so
  // the other tabs learn about a sign in or sign out from the
  // local storage they all share instead.
  monitorSession: false,
  // Renewing uses the refresh token that the `offline_access`
  // scope gets us, so it never reaches the iframe.
  automaticSilentRenew: true,
  scope: 'openid profile email offline_access',
})
